<template>
  <drag-modal :visible="visible"
              :loading="loading"
              width="4.5rem"
              @cancel="() => (visible = false)">
    <div class="flex-row justify-between align-center"
         slot="title">
      <div class="flex-row flex-1">
        <span class="font-bold trans-o-left"
              style="transform: scale(0.931944); font-size: 14px;">{{ title }}{{ data.Name }}</span>
      </div>
      <div>
        <span style="padding-right: 13.9792px;padding-left: 13.9792px;display: inline-block;font-size: 14px;transform: scale(0.815451);">
          距离设定原点 <span class="font-bold">{{data.Distance}}</span> 米</span>
      </div>
    </div>
    <div>
      <div class="flex-column center"
           style="font-size: 14px;
            transform: scale(0.915451);">
        <span v-if="data.WorkStatus == 2"
              style="color: green">(在线)</span><span v-else
              style="color: red">离线</span>
        <div style="float: right">采集时间：{{ data.LastDateTimeText }}</div>
      </div>
    </div>
    <div class="flex-column center"
         style="margin-top: 18.1729px">
      <ul class="clearfix device-list flex-wrap">
        <li class="flex-row"
            v-bind:id="item.Id"
            v-bind:key="item.Id"
            v-bind:name="item.Name"
            v-for="(item) in data.Tags"
            v-bind:style="{display:(item.Distance? 'block' : 'none')}"
            style="width: 100%;margin-top: 13.9792px; padding-left: 13.9792px;font-size: 11px; ">
          <div v-if="item.Distance">
            <span style="width: 29.3562px; height: 29.3562px; margin-right: 6.98958px; transform: scale(1);margin-left: 5px; "></span>
            <span style="transform: scale(0.931944);margin-left: 5px;">{{item.Name}} </span>
            <span style="transform: scale(0.931944);margin-left: 5px; ">{{item.LastDateTimeText}}</span>
            <span style="transform: scale(0.931944); margin-left: 5px;">位于基站</span>
            <span v-if="item.Direction == 0"
                  style="transform: scale(0.931944);margin-left: 5px; ">左侧</span>
            <span v-else
                  style="transform: scale(0.931944); margin-left: 5px;">右侧</span>
            <span style="transform: scale(0.931944); margin-left: 5px;">{{ item.Distance }}</span>
            <span style="transform: scale(0.931944); margin-left: 5px;">米</span>
          </div>
        </li>
      </ul>
    </div>
  </drag-modal>
</template>
<script>
import DragModal from "@/components/DragModal";
export default {
  data () {
    return {
      loading: true,
      visible: false,
      title: "UWB定位基站",
      data: {},
      colorData: {
        textStyle: "#3fc0fb",
        series: {
          color: ["#00bcd44a", "transparent"],
          dataColor: {
            normal: "#03a9f4",
            shadowColor: "#97e2f5",
          },
        },
      },
    };
  },
  components: {
    DragModal,
  },
  methods: {
    openForm (device) {
      console.log(device);
      this.title = device.DeviceMethodStr;
      this.loading = false;
      this.visible = true;
      this.data = device;
    },
  },
};
</script>
<style scoped>
.align-center {
  align-items: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  text-align: center;
}
.device-list li {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
}
</style>